import React from "react";
import { Link } from "react-router-dom";
import { featuredProjects, projectHighlights } from "../../data/siteData";

function Projects() {
  return (
    <div className="page">
      <section className="page-hero">
        <p className="section-eyebrow">Projects</p>
        <h1>Work examples that show both the range and finish quality of the portfolio.</h1>
        <p>
          The photo library covers modern residences, decorative installations,
          stair systems, tank structures and larger commercial-facing fabrication.
        </p>
      </section>

      <section className="section">
        <div className="project-grid project-grid--full">
          {featuredProjects.map((project) => (
            <article key={project.title} className="project-card">
              <img src={project.image} alt={project.title} />
              <div>
                <p>{project.location}</p>
                <h2>{project.title}</h2>
                <p>{project.summary}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="section section--contrast">
        <div className="section-heading">
          <p className="section-eyebrow">Named highlights</p>
          <h2>Documented examples from the company’s project history.</h2>
        </div>
        <div className="stacked-cards">
          {projectHighlights.map((highlight) => (
            <article key={highlight} className="info-card info-card--compact">
              <p>{highlight}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="cta-band">
        <div>
          <p className="section-eyebrow">See more visuals</p>
          <h2>The gallery shows a wider spread of gates, rails, decorative pieces and structural work.</h2>
        </div>
        <div className="hero__actions">
          <Link className="button button--solid" to="/gallery">
            Open gallery
          </Link>
          <Link className="button button--ghost" to="/contact">
            Ask about a similar job
          </Link>
        </div>
      </section>
    </div>
  );
}

export default Projects;
